import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'opac-table-cell',
  templateUrl: './table-cell.component.html',
  styleUrls: ['./table-cell.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TableCellComponent {
}
